<script setup lang="ts">
import { ref, nextTick } from "vue"
import { useMotion } from "@vueuse/motion"
import { useSpring } from "@/composables/use-spring"

const props = defineProps<{
  aboutHtml: string
  poolReady: boolean
}>()

const emit = defineEmits<{
  dismiss: []
}>()

const overlayRef = ref<HTMLElement>()
const isLeaving = ref(false)
const { config } = useSpring("gentle")
const { apply } = useMotion(overlayRef, { initial: {} })

async function handleDismiss() {
  if (isLeaving.value || !props.poolReady) return
  isLeaving.value = true

  await new Promise<void>(r => setTimeout(r, 300))

  const h = overlayRef.value?.scrollHeight ?? 0
  apply({ height: h, opacity: 0 })
  await nextTick()
  apply({ height: 0, opacity: 0, transition: { height: config } })

  await new Promise<void>(r => setTimeout(r, 600))
  emit("dismiss")
}
</script>

<template>
  <div
    ref="overlayRef"
    @click="handleDismiss"
    class="font-serif absolute inset-0 z-20 backdrop-blur-3xl text-black flex flex-col items-center justify-center p-4 text-center overflow-hidden"
    :class="{
      'cursor-wait': !poolReady,
      'cursor-pointer': poolReady,
      'bg-white/90': !poolReady,
      'bg-white/50': poolReady,
    }"
    :style="{ opacity: isLeaving ? '0' : '1', transition: 'opacity 0.3s ease' }"
  >
    <div
      class="text-[calc(1vw+1em)] max-w-[32em] body-text leading-[1.175] text-center mb-4"
    >
      <p>
        AA Projects Review 2026<br />
        <i>Critical Mass</i>
      </p>
      <div v-html="aboutHtml"></div>
    </div>
    <div class="text-sm" v-if="!poolReady">Loading...</div>
    <div class="text-sm" v-else>Click to continue</div>
  </div>
</template>
